import type { UpdateTransferQueueStatus } from '../server.ts'
import type { UpdateTransferTask } from '../Types/types.ts'

export function mergeUpdateTransferQueueStatus(
    task: UpdateTransferTask,
    queueStatus: UpdateTransferQueueStatus,
): UpdateTransferTask {
    if (queueStatus.status === 'queued') {
        return task
    }

    if (queueStatus.status === 'running') {
        if (task.status !== 'running' || task.stage !== 'queued') {
            return task
        }

        return {
            ...task,
            step: Math.max(task.step, 1),
            progress: Math.max(task.progress, 45),
            stage: 'update',
            message: queueStatus.message,
        }
    }

    if (queueStatus.status === 'completed') {
        return {
            ...task,
            step: task.totalSteps,
            progress: 100,
            status: 'success',
            stage: 'completed',
            message: queueStatus.message,
        }
    }

    return {
        ...task,
        status: 'error',
        stage: 'failed',
        message: queueStatus.message,
    }
}
